import React, { useMemo } from "react";
import { Redirect, useRouteMatch } from "react-router";
import ShoppingCartEditTemplateProduct from "../Components/EditTemplateProduct/ShoppingCartEditTemplateProduct";
import { useShoppingCart } from "../../providers/ShoppingCartProvider";
import ShoppingCartEditPackage from "../Components/EditTemplateProduct/ShoppingCartEditPackage";

export default () => {
  const match = useRouteMatch();
  const { items, loading } = useShoppingCart();

  const orderLine = useMemo(() => {
    return items.find((item) => item.uuid == match.params.uuid);
  }, [items, match]);

  if (loading) {
    return <div>Loading</div>;
  }

  if (!orderLine) {
    return <Redirect to={"/shopping-cart"} />;
  }

  switch (orderLine.product.type) {
    case 1:
    case 2:
    case 89:
      return <ShoppingCartEditTemplateProduct orderLine={orderLine} />;
    case 200:
      return <ShoppingCartEditPackage orderLine={orderLine} />;
  }
  return <div>Loading</div>;
};
